import { render, staticRenderFns } from "./busRouteReturnIndex.vue?vue&type=template&id=807142e2&"
import script from "./busRouteReturnIndex.vue?vue&type=script&lang=js&"
export * from "./busRouteReturnIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports